<h2>History</h2>
<mat-spinner *ngIf="isLoading" color="primary" diameter="50"></mat-spinner>
<form [formGroup]="historyFormGroup" *ngIf="calls.length > 0">
  <mat-radio-group aria-labelledby="radio-group-calls" formControlName="call">
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z8"
      *ngIf="!isLoading"
    >
      <ng-container matColumnDef="selection">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Selected
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <mat-radio-button
            [value]="element"
            [checked]="element == selectedCall"
            color="primary"
          ></mat-radio-button>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Date
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          {{ element.date | date : "shortDate" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="hour">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Hour
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          {{ element.date | date : "HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          User
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          {{ element.user.username }}
        </td>
      </ng-container>

      <ng-container matColumnDef="numberPlate">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Number plate
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <span *ngIf="element.numberPlate">{{ element.numberPlate }}</span>
          <fa-icon
            *ngIf="!element.numberPlate"
            [icon]="faQuestion"
            class="question"
            matTooltip="No number detected on this plate"
          ></fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="userAnswer">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Your answer
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <fa-icon
            [icon]="faCheck"
            *ngIf="element.userAnswer == true"
            class="check"
            matTooltip='You answered "correct"'
          ></fa-icon>
          <fa-icon
            [icon]="faCross"
            *ngIf="element.userAnswer == false"
            class="cross"
            matTooltip='You answered "incorrect"'
          ></fa-icon>
          <fa-icon
            [icon]="faQuestion"
            *ngIf="element.userAnswer == null"
            class="question"
            matTooltip="You have not answered"
          ></fa-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      *ngIf="calls.length > 1"
      [pageSizeOptions]="[5, 10, 25, 100]"
      aria-label="Select page of ANPR calls"
      [ngClass]="{ invisible: isLoading }"
    >
    </mat-paginator>
  </mat-radio-group>
</form>
<p *ngIf="calls.length == 0 && !isLoading">No calls for the moment.</p>
